document.addEventListener('DOMContentLoaded', function() {
  const navItems = document.querySelectorAll('.header__navItem');
  
  navItems.forEach(item => {
    const button = item.querySelector('.header__arrowButton');
    const popover = item.querySelector('.header__popover');
    
    if (button && popover) {

      button.addEventListener('click', (e) => {
        e.preventDefault();
        toggleMenu(popover, button);
      });

      // Toggle menu on keyboard
      button.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggleMenu(popover, button);
        }
        if (e.key === 'Escape') {
          closeMenu(popover, button);
        }
      });

      // Close menu when clicking outside
      document.addEventListener('click', (e) => {
        if (!item.contains(e.target)) {
          closeMenu(popover, button);
        }
      });

      popover.addEventListener('focusout', (e) => {
        setTimeout(() => {
          if (!popover.contains(document.activeElement) && document.activeElement !== button) {
            closeMenu(popover, button);
          }
        }, 0);
      });

      // Handle focus on popover links
      const popoverLinks = popover.querySelectorAll('a');
      popoverLinks.forEach(link => {
        link.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') {
            closeMenu(popover, button);
            button.focus();
          }
        });
      });
    }
  });

  function toggleMenu(popover, button) {
    const isOpen = popover.style.display === 'flex';
    if (isOpen) {
      closeMenu(popover, button);
    } else {
      openMenu(popover, button);
    }
  }

  function openMenu(popover, button) {
    popover.style.display = 'flex';
    button.setAttribute('aria-expanded', 'true');
  }

  function closeMenu(popover, button) {
    popover.style.display = 'none';
    button.setAttribute('aria-expanded', 'false');
  }
}); 